import { observable } from 'mobx'
import { IUser, IComment, IScreenshots, IInviter, IReviewModel } from '.'
import { chatable } from '../shared/decorators/communicator'
import { convertDateToUserLocal } from '../shared/DateConverter'
/**
 * Model for current and other users in the system
 */

@chatable
export default class ReviewModel {
  store
  @observable id: number
  @observable users: Array<IUser> = []
  @observable inviters: Array<IInviter> = []
  @observable comments: IComment[] = []
  @observable screenshots: IScreenshots[] = []

  constructor(store: any, obj: IReviewModel) {
    this.store = store
    Object.assign(this, obj)
    this.adjustDateTimeToUser()
  }

  update(obj: IReviewModel) {
    if (obj.users && obj.users.length > 0) {
      // filter out any users that lack an id or name
      obj.users = obj.users.filter(user => user.id && user.name)
    }
    Object.assign(this, obj)
    this.adjustDateTimeToUser()
  }

  // this should only be done after an update from the Server, which uses UTC
  adjustDateTimeToUser() {
    this.comments.forEach((comment) => {
      comment.createdAt = convertDateToUserLocal(comment.createdAt)
    })
  }

  toJS() {
    return {
      id: this.id,
      users: this.users,
      inviters: this.inviters,
      comments: this.comments,
      screenshots: this.screenshots,
    }
  }

  static fromJS(store, data) {
    return new ReviewModel(store, data)
  }

}
